import { useState } from "react";
import { Box, Drawer, IconButton, Tooltip, Typography, useMediaQuery, useTheme } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import ChatIcon from '@mui/icons-material/Chat';
import { useNavigate } from "react-router-dom";
import { useChat } from "./ChatProvider";
import ChatListaConversas from "./ChatListaConversas";
import ChatJanela from "./ChatJanela";
import ModalGrupoChat from "./ModalGrupoChat";

// Drawer global do chat: montado uma vez no Template, disponivel em qualquer tela
export default function ChatWidget() {
    const { habilitado, aberto, fecharChat, conversaAtiva, conversaAtivaId, abrirConversa } = useChat();
    const navigate = useNavigate();
    const theme = useTheme();
    const telaPequena = useMediaQuery(theme.breakpoints.down('md'));

    const [openGrupo, setOpenGrupo] = useState(false);
    const [editandoGrupo, setEditandoGrupo] = useState(false);

    if (!habilitado) return null;

    // Em tela pequena mostra uma coluna por vez (lista OU conversa)
    const mostrarLista = !telaPequena || !conversaAtivaId;
    const mostrarJanela = !telaPequena || Boolean(conversaAtivaId);

    return (
        <>
            <Drawer
                anchor="right"
                open={aberto}
                onClose={fecharChat}
                PaperProps={{
                    sx: {
                        width: { xs: '100%', sm: 420, md: 720 },
                        maxWidth: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                    },
                }}
            >
                {/* Cabeçalho do widget */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 1.5,
                        py: 1,
                        bgcolor: 'primary.main',
                        color: '#fff',
                    }}
                >
                    <ChatIcon fontSize="small" />
                    <Typography sx={{ flex: 1, fontSize: 14, fontWeight: 'bold' }}>
                        Chat Interno
                    </Typography>
                    <Tooltip title="Abrir em tela cheia">
                        <IconButton
                            size="small"
                            sx={{ color: '#fff' }}
                            onClick={() => {
                                fecharChat();
                                navigate('/chat');
                            }}
                        >
                            <OpenInFullIcon sx={{ fontSize: 17 }} />
                        </IconButton>
                    </Tooltip>
                    <IconButton size="small" sx={{ color: '#fff' }} onClick={fecharChat}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>

                <Box sx={{ flex: 1, display: 'flex', minHeight: 0 }}>
                    {mostrarLista && (
                        <Box
                            sx={{
                                width: telaPequena ? '100%' : 280,
                                flexShrink: 0,
                                borderRight: '1px solid #e0e0e0',
                                minHeight: 0,
                            }}
                        >
                            <ChatListaConversas
                                onNovoGrupo={() => {
                                    setEditandoGrupo(false);
                                    setOpenGrupo(true);
                                }}
                            />
                        </Box>
                    )}

                    {mostrarJanela && (
                        <ChatJanela
                            onVoltar={telaPequena ? () => abrirConversa(null) : undefined}
                            onEditarGrupo={() => {
                                setEditandoGrupo(true);
                                setOpenGrupo(true);
                            }}
                        />
                    )}
                </Box>
            </Drawer>

            <ModalGrupoChat
                open={openGrupo}
                setOpen={setOpenGrupo}
                grupo={editandoGrupo ? conversaAtiva : null}
                zIndex={3500}
            />
        </>
    );
}
